import React, {Component} from 'react';
import DataFormat from "../../../../../../utilities/DateAndTimeFormat";
import {FormControl, Form} from "react-bootstrap";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";

export default class PokazRozkladGodzinaOdjazdu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nowa_godzina: ''
        };
        this.onChangeGodzina = this.onChangeGodzina.bind(this);
        this.onClickZapisz = this.onClickZapisz.bind(this);
    }

    onChangeGodzina(e) {
        this.setState({nowa_godzina: e.target.value})
    }

    onClickZapisz() {

        if (this.state.nowa_godzina !== '' || this.state.nowa_godzina !== null) {
            this.props.handleChangeGodzina(this.state.nowa_godzina)
        }
        this.setState({nowa_godzina: ''})

    }

    render() {

        return (
            <div>
                <Form inline={true}>
                    <FormControl type={'time'} defaultValue={DataFormat.formatHHMM(this.props.godzina)} onChange={this.onChangeGodzina}/>
                    <span style={{width: '10px', display: "inline-block"}}></span>
                    {
                        (this.state.nowa_godzina !== '') ?
                            <TopButtonAction onClick={this.onClickZapisz} iconType={'fa fa-save'} text={'Zapisz'}/>
                            :
                            ''
                    }

                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/rozklad/pokazRozklad/components/PokazRozkladGodzinaOdjazdu.js